const fundsTransfersTable = {
  columns: {
    getColumnsData: 'fundsTransfersColumnsData',
    setColumnsData: 'setFundsTransfersColumnsData'
  },
  rows: {
    getRowsData: 'fundsTransfersRowsData',
    setRowsData: 'setFundsTransfersRowsData'
  }
}

const fundsTransfersTableColumns = [
  {
    id: 1,
    title: 'DATE',
    type: 'date',
    property: 'date'
  },
  {
    id: 2,
    title: 'SOURCE FUND',
    property: 'sourceFund'
  },
  {
    id: 3,
    title: 'DESTINATION FUND',
    property: 'destinationFund'
  },
  {
    id: 4,
    title: 'AMOUNT',
    property: 'amount'
  }
]

export {fundsTransfersTable, fundsTransfersTableColumns}



// WEBPACK FOOTER //
// ./src/constants/TablesOptions/fundsTransfers.js